<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>班级管理</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{ managerName }}</p>
        </div>
        <div class="course_btn">
          <div
            class="add-btn"
            style="margin-bottom:0;"
            @click="showAddWindow"
          >添加班级</div>
        </div>
      </div>

      <div id="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">小班名称</th>
              <th class="itemStatus">负责教师</th>
              <th class="itemStatus">小班人数</th>
              <th
                class="action"
                width="130"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="(item,index) in tableData"
              :key="index"
            >
              <td class="itemStatus">{{item.title}}</td>
              <td class="itemStatus">{{managerName}}</td>
              <td class="itemStatus">{{item.student_count}}</td>
              <td class="action">
                <a
                  class="edit"
                  href="javascript:;"
                  @click="showUserWindow(item.id)"
                >查看学生</a>
                <a
                  class="edit"
                  href="javascript:;"
                  @click="querySingle(item.id)"
                >编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-if="!tableData.length"
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      class="form_overlay"
      style="z-index: 2;"
      :style="classShowAddWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">班级管理</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>名称:</span>
              <input
                type="text"
                v-model="formInfo.title"
                autocomplete="off"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>教师:</span>
              <input
                type="text"
                :value="managerName"
                disabled
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideAddWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveInfo"
          >提交</a>
        </div>
      </div>
    </div>
    <!-- 用户弹窗 -->
    <div
      id="c-panel"
      :style="classShowUserWindow"
    >
      <div id="c-panel-bg"></div>

      <div class="c-content">
        <form
          id="search"
          onsubmit="return false;"
        >
          <input
            type="text"
            class="s-text"
            placeholder="用户名"
            autocomplete="off"
            v-model="formSearchUser.username"
          >
          <input
            type="text"
            class="s-text"
            placeholder="姓名"
            autocomplete="off"
            v-model="formSearchUser.name"
          >
          <select
            class="s-text"
            v-model="formSearchUser.school_id"
            @change="getSchoolAcademy(formSearchUser.school_id)"
          >
            <option value=''>请选择学校</option>
            <option
              v-for="(item, index) in searceSchoolData"
              :key="index"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
          <select
            class="s-text"
            v-model="formSearchUser.academy_id"
          >
            <option value=''>请选择院系</option>
            <option
              v-for="item in searchAcademyData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.title }}
            </option>
          </select>
          <input
            type="submit"
            class="s-btn1"
            @click="getUserList"
            value="查询"
          >
          <span
            class="close-cpanel"
            @click="hideUserWindow"
          ></span>
        </form>
        <div id="uList">
          <table>
            <tbody>
              <tr class="l_header">
                <th>用户名</th>
                <th>姓名</th>
                <th>性别</th>
                <th>学校</th>
                <th>院系</th>
              </tr>
              <tr
                class="item"
                v-for="(item,index) in userData"
                :key="index"
              >
                <td>{{ item.userProfile.username }}</td>
                <td>{{ item.userProfile.name }}</td>
                <td>{{ formatGender(item.userProfile.gender) }}</td>
                <td>{{formatSchool(item.userProfile.school)}}</td>
                <td>{{formatAcademy(item.userProfile.academy)}}</td>
              </tr>
              <tr v-if="!userData.length">
                <td colspan="5">暂时没有数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 分页 -->
        <pagination
          v-if="userData.length"
          :cur='teacherPageInfo.page'
          :all='teacherPageInfo.all'
          :totalData="teacherPageInfo.totalData"
          :callback="pageUserCallback"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'OnlineTeacher',
  components: {
    Pagination
  },
  props: [
    'lessonInfo'
  ],
  data() {
    return {
      queryInfo: {
        page: 1,
        size: 10,
        lessonOnline_id: this.$route.query.id
      },
      formInfo: {
        id: 0,
        lessonOnline_id: this.$route.query.id,
        title: ''
      },
      tableData: [],
      tableDataCount: 0,
      classShowAddWindow: {},
      formSearchUser: {
        onlineClass_id: '',
        page: 1,
        size: 10,
        username: '',
        name: '',
        academy_id: '',
        school_id: ''
      },
      classShowUserWindow: {
        visibility: 'hidden'
      },
      searceSchoolData: [],
      searchAcademyData: [],
      userData: [],
      userDataCount: 0,
      academyData: []
    }
  },
  methods: {
    formatGender(value) {
      if (value === '1') {
        return '男'
      } else if (value === '0') {
        return '女'
      } else if (value === '男' || value === '女') {
        return value
      } else {
        return '--'
      }
    },
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.getClass()
    },
    // 新建弹窗
    showAddWindow() {
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    hideAddWindow() {
      this.classShowAddWindow = {}
      this.formInfo = {
        id: 0,
        lessonOnline_id: this.$route.query.id,
        title: ''
      }
    },
    async getClass() {
      await this.$http.get('/online_class/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取课程列表失败！')
      })
    },
    // 编辑时查询
    async querySingle(id) {
      const url = '/online_class/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo.id = data.id
        this.formInfo.title = data.title
        this.classShowAddWindow = {
          visibility: 'visible'
        }
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
    },
    async saveInfo() {
      if (!this.formInfo.title) {
        this.$layer.msg('请填写班级名称！')
        return
      }
      const titleData = await this.$http.get('/online_class/', {
        params: {
          eq_title: this.formInfo.title,
          lessonOnline_id: this.$route.query.id
        }
      })
      if (this.formInfo.id) {
        if (titleData.results.length > 0 && titleData.results[0].id !== this.formInfo.id) {
          this.$layer.msg('课程名称已存在！')
          return
        }
        const url = '/online_class/' + this.formInfo.id + '/'
        await this.$http.put(url, this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('修改成功！')
            this.hideAddWindow()
            this.getClass()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('修改失败！')
        })
      } else {
        if (titleData.results.length > 0) {
          this.$layer.msg('课程名称已存在！')
          return
        }
        await this.$http.post('/online_class/', this.formInfo).then((data) => {
          if (data.id) {
            this.$parent.showMsg('添加成功！')
            this.hideAddWindow()
            this.getClass()
          } else {
            this.$parent.showMsg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('添加失败！')
        })
      }
    },
    // 查看学生
    async getUserList() {
      await this.$http.get('/online_student/', {
        params: this.formSearchUser
      }).then((data) => {
        this.userData = data.results
        this.userDataCount = data.count
      }).catch((error) => {
        console.log(error)
        this.$parent.showMsg('数据获取失败！')
      })
    },
    showUserWindow(id) {
      this.userData = []
      this.userDataCount = 0
      this.formSearchUser.onlineClass_id = id
      this.formSearchUser.username = ''
      this.formSearchUser.name = ''
      this.formSearchUser.school_id = ''
      this.formSearchUser.academy_id = ''
      this.formSearchUser.page = 1
      this.classShowUserWindow = {
        visibility: 'visible'
      }
      this.getUserList()
    },
    hideUserWindow() {
      this.classShowUserWindow = {
        visibility: 'hidden'
      }
    },
    pageUserCallback(data) {
      this.formSearchUser.page = data
      this.getUserList()
    },
    // 获取所有学校数据
    async getSchool() {
      const params = {
        page: 1,
        size: 10000,
        status: 1
      }
      await this.$http.get('/school/', { params }).then((data) => {
        this.searceSchoolData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取学校下的所有院系
    async getSchoolAcademy(value) {
      const params = {
        page: 1,
        size: 10000,
        school_id: value,
        status: 1
      }
      if (value) {
        await this.$http.get('/academy/', { params }).then((data) => {
          this.searchAcademyData = data.results
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.searchAcademyData = []
      }
    },
    // 根据学校id获取学校名称
    formatSchool(value) {
      const schoolId = this.searceSchoolData.map(item => item.id)
      return this.searceSchoolData[schoolId.indexOf(value)] ? this.searceSchoolData[schoolId.indexOf(value)].title : '--'
    },
    // 根据院系id获取院系名称
    formatAcademy(value) {
      const academyId = this.academyData.map(item => item.id)
      return this.academyData[academyId.indexOf(value)] ? this.academyData[academyId.indexOf(value)].title : '--'
    },
    // 获取所有院系数据用于筛选
    async getAcademy() {
      const params = {
        page: 1,
        size: 10000
      }
      await this.$http.get('/academy/', { params }).then((data) => {
        this.academyData = data.results
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    this.getClass()
    this.getSchool()
    this.getAcademy()
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    },
    managerName() {
      return this.lessonInfo.manager && this.lessonInfo.manager ? this.lessonInfo.manager.name : ''
    },
    teacherPageInfo() {
      return {
        page: this.formSearchUser.page,
        all: Math.ceil(this.userDataCount / this.formSearchUser.size),
        totalData: this.userDataCount
      }
    }
  }
}
</script>

<style scoped src="@/assets/css/project-detail.css"></style>

<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
.itemStatus {
  img {
    width: 120px;
  }
}
#c-panel {
  z-index: 2;
}
.c-content {
  min-height: 500px;
}
.active {
  color: #266dc7 !important;
  text-decoration: underline;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.crumb_nav {
  color: #999;
  margin-top: 20px;
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
#uList td {
  padding: 2px 4px;
}
</style>
